import { ITipoOrdenBalanza } from '../../modelos/ITipoOrdenBalanza';
import { TipoOrdenesBalanzaService } from '../../services/tipo-ordenes-balanza.service';
import { IOrdenBalanza } from '../../modelos/IOrdenBalanza';
import { LfsaBotonEditarGridComponent} from '../../../../shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { UtilsService } from '../../../../shared/utils/utils.service';
import { FormBuilder, FormControl, FormGroup, ValidationErrors, Validators, } from '@angular/forms';
import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { moduloGaritas } from '../../diccionarios/balanzaModulo.js';
import { OrdenBalanzaService } from '../../services/orden-balanza.service';
import * as printJS from 'print-js';
import { PlacaService } from '../../services/placa-transportista.service';
import { IPlaca } from '../../modelos/IPlaca';
import { UsuarioBasculaGaritaService } from '../../services/usuario-bascula-garita.service';
import { TicketAutorizacionTransporteService } from '../../services/ticket-autorizacion-transporte.service';
import { MantenimientoBasculaService } from '../../services/mantenimiento-bascula.service';
import { AlmacenService } from '../../services/almacen.service';
import { IAlmacen } from '../../modelos/IAlmacen';
import { OrdenCompraService } from '../../services/orden-compra.service';
import { debounceTime } from 'rxjs/operators';
import { CentrosService } from '../../services/centros.service';
import { ICentros } from '../../modelos/ICentros';
import { MaterialService } from '../../services/material.service';
import { ProveedorService } from '../../services/proveedor.service';
import { ClienteService } from '../../services/cliente.service';
import Swal from 'sweetalert2';
import { OrdenesReferenciaMaquinaService } from '../../services/ordenes-referencia-maquina.service';
import { MantenimientoOrigenesExtractorasService } from '../../services/mantenimiento-origenes-extractoras.service';
import { IMantBascula } from '../../modelos/IMantBascula';

@Component({
  selector: 'app-ordenes-reasignacion',
  templateUrl: './ordenes-reasignacion.component.html',
  styleUrls: ['./ordenes-reasignacion.component.css'],
})

export class OrdenesReasignacionComponent implements OnInit {
  public loading: boolean = false;
  public imprimirCapturaEntradaLoading: boolean = false;
  public imprimirCapturaSalidaLoading: boolean = false;

  public DAT_TITULOS: any = moduloGaritas.titulos.ordenesReasignación;
  public DAT_BTNS: any = moduloGaritas.button.buttonsNombre;
  public DAT_BTNCSS: any = moduloGaritas.button.buttonsCss;
  public DAT_MSG: any = moduloGaritas.mensajes;
  public DAT_AG_GRID: any = moduloGaritas.agGrid;

  public columnDefs: any[] = [];
  public rowData: any[] = [];
  public gridApi: any;
  public gridColumnApi: any;
  public frameworkComponents: any;
  public tituloModal: string;
  public isCreate: boolean = true;
  public cmbMaterial: any[] = [];

  public status = 'INGRESADA';
  public requiereOrden = true;
  public generaLoteInspeccionSAP = true;
  public ingresoObligatorioParametrosCalidad = true;
  public ingresoTicketDeEntrada = true;
  public granel = true;
  public ordenSelected: IOrdenBalanza;
  public cmbTipoOrden: ITipoOrdenBalanza[] = [];
  public cmbTipoOrdenAuxiliar: ITipoOrdenBalanza[] = [];
  public cmbTipoPermiteCambio: ITipoOrdenBalanza[] = [];
  public placaResponse: IPlaca = {} as IPlaca;
  public almacenesCmb: IAlmacen[] = [];
  public centrosCmb: ICentros[] = [];
  public capturaPesoIn: boolean = false;
  public capturaPesoInAction: boolean = false;
  public comboBalanzas: IMantBascula[] = [];
  fomularioPeso: FormGroup;

  public agregarForm = new FormGroup({
    // Mantenimiento de Ordenes de Balanza
    estado: new FormControl(0),
    orden: new FormControl(null),
    fecha: new FormControl(null),
    tipo: new FormControl(null, [Validators.required]),
    numero: new FormControl(null, [Validators.required]),
    numOrdAlt: new FormControl(null, [Validators.required]),
    emptyIncome: new FormControl(null),
    freightNumber: new FormControl(null),
    factura: new FormControl(null),
    guia: new FormControl(null),
    proveedorId: new FormControl(null),
    proveedor: new FormControl(null),
    cliente: new FormControl(null),
    ordBalanzaOrigen: new FormControl(null),
    pesoBalanzaOrigen: new FormControl(null),
    sellos: new FormControl(null),
    contenedor: new FormControl(null, [Validators.maxLength(12)]),
    material: new FormControl(null, [Validators.pattern(/[0-9]+/)]),
    desmat: new FormControl(null),
    despro: new FormControl(null),
    descli: new FormControl(null),

    // INFO DEL TICKET DE AUTORIZACIÓN DE TRANSPORTE
    ticketAuth: new FormControl(null, [Validators.required, Validators.pattern(/[0-9]+/)]),
    placa: new FormControl(null, [Validators.required, Validators.pattern(/[A-Za-z]+/)]),
    chofer: new FormControl(null, [Validators.required]),
    cedChofer: new FormControl(null, [Validators.required]),
    // ORIGEN
    centroOri: new FormControl(null, [Validators.pattern(/[A-Za-z0-9]+/)]),
    almanceOri: new FormControl(null, [Validators.pattern(/[A-Za-z]+/)]),
    // DESTINO
    centroDest: new FormControl(null, [Validators.pattern(/[A-Za-z0-9]+/)]),
    almaceDest: new FormControl(null, [Validators.pattern(/[A-Za-z]+/)]),

    // Datos recibidos del proveedor
    // DATOS RECIBIDOS
    origOrd: new FormControl(null),
    pesoBruto: new FormControl(null),
    pesoNeto: new FormControl(null, Validators.min(0)),
    tara: new FormControl(null),
    // CALIDAD RECIBIDA
    acidez: new FormControl(null),
    humedad: new FormControl(null),
    impureza: new FormControl(null),

    //Tipo de Orden
    clasePerdido: new FormControl('', [Validators.maxLength(4)]),
    orgCompra: new FormControl('', []),
    grupoCompra: new FormControl('', []),

    // Orden de compra
    ocStatus: new FormControl(null),
    solpedNumber: new FormControl(null),
    ocNumber: new FormControl(null),
    creationDateOC: new FormControl(null),
    updateDateOC: new FormControl(null),

    // Informaciín del lote de inspección
    loteInsp: new FormControl(null),
    decisionEmpleo: new FormControl(null),
    gradoApi: new FormControl(null),
    calidad: new FormControl(null),
    inspectionLotAcidity: new FormControl(null),
    inspectionLotMoisture: new FormControl(null),
    inspectionLotImpurity: new FormControl(null),

    // Captura de pesos Entrada/Salida
    // CAPTURA DE PESOS ENTRADA
    fechIn: new FormControl(null, Validators.required),
    horaEntrada: new FormControl(null, Validators.required),
    pesoIn: new FormControl(null, Validators.required),
    // CAPTURA DE PESOS SALIDA
    fechOut: new FormControl(null),
    horaSalida: new FormControl(null),
    pesoOut: new FormControl(null),

    // Información de la Balanza
    idOrden: new FormControl(null),
    ordenFija: new FormControl(null, [Validators.required]),
    ordenFijaDescription: new FormControl(null, [Validators.required]),
    idusuario: new FormControl(null, [Validators.required]),
    usuario: new FormControl(null, [Validators.required]),
  });
  public digiteTicketAutorizacionDuplicated: boolean = false;
  ncasosSolped;
  public tipoDeOrden;
  public tipoDeOrdenObj;
  public showIngresoVacio = false;
  public showNumeroDeOrden = false;
  materialInvalido = false;
  proveedorInvalido = false;
  clienteInvalido = false;

  constructor(
    private fb: FormBuilder,
    private _util: UtilsService,
    private ordenBalanzaS: OrdenBalanzaService,
    private tipoOrdenesBalanzaS: TipoOrdenesBalanzaService,
    private placaS: PlacaService,
    private usuarioBasculaGaritaS: UsuarioBasculaGaritaService,
    private mantenimientoBasculaS: MantenimientoBasculaService,
    private ticketAutorizacionTransporteS: TicketAutorizacionTransporteService,
    private almacenS: AlmacenService,
    private ordenCompraS: OrdenCompraService,
    private centrosS: CentrosService,
    private materialS: MaterialService,
    private proveedorS: ProveedorService,
    private clienteS: ClienteService,
    private ordenesReferenciaMaquinaS: OrdenesReferenciaMaquinaService,
    private MantenimientoOrigenesExtractorasService: MantenimientoOrigenesExtractorasService,
  ) {
  }

  gridComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'N# Orden',
        field: 'idOrden',
        sortable: true,
        filter: true,
        width: 50,
      },
      {
        headerName: 'Tipo Orden',
        field: 'tipoOrden.desca',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Balanza',
        field: "bascula.desca",
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Estado',
        field: 'estado',
        width: 50,
        sortable: true,
        filter: true,
      },
      {
        headerName: 'REASIGNAR BASCULA',
        cellRenderer: 'buttonRenderer',
        width: 50,
        cellRendererParams: {
          onClick: this.editar.bind(this),
          label: 'Ver',
          colorBoton: this.DAT_BTNCSS.info,
        },
      },
    ];
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    params.api.sizeColumnsToFit();
  }

  ngOnInit(): void {

    this.fomularioPeso = this.fb.group({pesoBalanza: ['']});

    this.gridComponent();
    this.obtenerOrdenesBalanza();
    this.obtenerTipoOrdenBalanza();
    this.obtenerOrigenesExtractoras();
    this.obtenerBalanzas();

    this.agregarForm.get('idOrden')?.disable({ onlySelf: true });
    this.agregarForm.get('factura')?.disable({ onlySelf: true });
    this.agregarForm.get('guia')?.disable({ onlySelf: true });

    this.agregarForm.get('ordBalanzaOrigen')?.disable({ onlySelf: true });
    this.agregarForm.get('pesoBalanzaOrigen')?.disable({ onlySelf: true });
    this.agregarForm.get('chofer')?.disable({ onlySelf: true });
    this.agregarForm.get('cedChofer')?.disable({ onlySelf: true });

    this.agregarForm.get('loteInsp')?.disable({ onlySelf: true });
    this.agregarForm.get('decisionEmpleo')?.disable({ onlySelf: true });
    this.agregarForm.get('gradoApi')?.disable({ onlySelf: true });
    this.agregarForm.get('calidad')?.disable({ onlySelf: true });

    this.agregarForm.get('cedChofer')?.disable({ onlySelf: true });

    this.agregarForm.get('pesoOut').valueChanges
      .subscribe((resp) => {
        if (resp) {
          console.log("this.tipoDeOrden", this.tipoDeOrden)
          if (this.tipoDeOrden != 0 && this.tipoDeOrden != 4) {
            if (resp == "") this.agregarForm.get("pesoNeto").setValue(0);
            else {
              let pesoEntrada = this.agregarForm.get("pesoIn").value;
              let pesoSalida = this.agregarForm.get("pesoOut").value;
              let resultado = pesoEntrada - pesoSalida;

              //KARINA D. TICKET 156525, seter en orden de flete peso neto para validar estado en back
              //this.agregarForm.get("pesoNeto").setValue(resultado < 0 ? resultado * -1 : resultado);
            }
          }
        }
        else {
          //this.agregarForm.get("pesoNeto").setValue("");
        }
      });

    this.agregarForm.get('numero').valueChanges
      .subscribe((resp) => {
        console.log("numero').valueChanges", resp);
        if (resp) {
          console.log("numero change", resp)
          console.log("TIPOOO", this.tipoDeOrden)
          if (this.tipoDeOrden == 0) {
            this.buscarOC(resp);
          }
          if (this.tipoDeOrden == 1 || this.tipoDeOrden == 2) {
            this.buscarFleteSap(resp);
          }
          if (this.tipoDeOrden == 4) {
            this.buscarMaquila(resp);
          }
        }
        // else {
        //   this.agregarForm.get('estado').setValue(0);
        //   this.agregarForm.get('factura').setValue('');
        //   this.agregarForm.get('guia').setValue('');
        //   // this.agregarForm.get('proveedor').setValue('');
        //   this.agregarForm.get('cliente').setValue('');
        //   this.agregarForm.get('ordBalanzaOrigen').setValue('');
        //   this.agregarForm.get('pesoBalanzaOrigen').setValue('');
        // }
      });

    this.agregarForm.get('ticketAuth').valueChanges
      .pipe(debounceTime(1000))
      .subscribe((resp) => {
        if (resp) {
          this.ticketAuthTransp(resp);
        }
      });

    this.agregarForm.get('ordenFijaDescription').valueChanges
    .subscribe((valor) => {this.agregarForm.get('ordenFija').setValue(valor); });

    this.obtenerAlmacenes();
    this.obtenerCentros();

    this.agregarForm.get('pesoOut').valueChanges
      .subscribe((resp) => {
        this.getFormValidationErrors();
      });
  }

  buscarMaquila(maquila) {
    this.ordenesReferenciaMaquinaS.obtenerPorId(maquila).subscribe(
      resp => {
        if (!resp) {
          this._util.mensajeErroToast('Número de orden incorrecto.');
          return;
        }
        console.log("buscarMaquila resp", resp)

        this.agregarForm.get('material').setValue(resp.material);

        this.onChangeMaterial("");

        this._util.mensajeOKToast('Material correcto.');
      },
      error => {
        this._util.mensajeErroToast('Ocurrió un error al buscar el número de orden.');
      }
    );

  }

  ticketAuthTransp(id: number) {
    this.ticketAutorizacionTransporteS.obtenerPorId(id).subscribe(
      resp => {

        this.digiteTicketAutorizacionValidDuplicated();

        if (resp) {
          this.buscarPlacaTransporte(resp.placa);
          //Setea valor del Ticket de Garita
          console.log(resp);
          this.agregarForm.get('placa').setValue(resp.placa);
          this.agregarForm.get('chofer').setValue(resp.chofer);
          this.agregarForm.get('cedChofer').setValue(resp.cedula);
          this._util.mensajeOKToast('El ticket autorización transporte es válido.');
        }else{
          this.agregarForm.get('placa').reset();
          this.agregarForm.get('chofer').reset();
          this.agregarForm.get('cedChofer').reset();
          this._util.mensajeErroToast('El ticket autorización transporte es inválido.');
        }
      },
      error => {
        this.agregarForm.get('placa').reset();
        this.agregarForm.get('chofer').reset();
        this.agregarForm.get('cedChofer').reset();
        this._util.mensajeErroToast('El ticket autorización transporte es inválido.');
      }
    );

  }

  buscarOC(id: number) {
    this.ordenBalanzaS.buscarOC(this.agregarForm.get("numero").value).subscribe(
      resp => {
        if (!resp) {
          this._util.mensajeErroToast('Número de orden incorrecto.');
          return;
        }
        console.log("buscarOC resp", resp)

        this.agregarForm.get('centroDest').setValue(resp.idCentro.trim());
        this.agregarForm.get('almaceDest').setValue(resp.codAlmacen.trim());
        this.agregarForm.get('material').setValue(resp.codMaterial.trim());

        this.onChangeCliente("");
        this.onChangeMaterial("");
        this.onChangeProveedor("");

        this._util.mensajeOKToast('Número de Orden correcto.');
      },
      error => {
        this._util.mensajeErroToast('Ocurrió un error al buscar el número de orden.');
      }
    );
  }

  buscarFleteSap(id: number) {
    this.ordenBalanzaS.buscarFleteSap(this.agregarForm.get("numero").value).subscribe(
      resp => {
        if (!resp) {
          this._util.mensajeErroToast('Número de orden incorrecto.');
          return;
        }
        console.log("buscarFleteSap resp", resp)

        this.agregarForm.get('centroOri').setValue(resp.centroori);
        this.agregarForm.get('almanceOri').setValue(resp.almacenori);
        this.agregarForm.get('centroDest').setValue(resp.centrodest);
        this.agregarForm.get('almaceDest').setValue(resp.almacendest);
        if (resp.cliente) this.agregarForm.get('cliente').setValue(resp.cliente);
        this.agregarForm.get('contenedor').setValue(resp.contenedor);
        this.agregarForm.get('factura').setValue(resp.factura);
        this.agregarForm.get('guia').setValue(resp.guia);
        this.agregarForm.get('pesoBruto').setValue(resp.pesobruto);
        this.agregarForm.get('pesoBruto').disable();

        //KARINA D. TICKET 156525, seter en orden de flete peso neto para validar estado en back
        this.agregarForm.get('pesoNeto').setValue(resp.pesoneto);
        this.agregarForm.get('pesoNeto').disable();


        this.onChangeCliente("");

        this._util.mensajeOKToast('Número de Orden correcto.');
      },
      error => {
        this._util.mensajeErroToast('Ocurrió un error al buscar el número de orden.');
      }
    );
  }

  ordenCompra(id: number) {
    this.ordenCompraS.obtenerPorId(id).subscribe(
      resp => {
        if (!resp) {
          this._util.mensajeErroToast('Orden de compra incorrecto.');
          return;
        }
        this.agregarForm.get('estado').setValue(0);
        this.agregarForm.get('factura').setValue('EC-46546');
        this.agregarForm.get('guia').setValue('G-4646546');
        this.agregarForm.get('proveedor').setValue('Carlos SAC');
        this.agregarForm.get('cliente').setValue('Carlos');
        this.agregarForm.get('ordBalanzaOrigen').setValue('123');
        this.agregarForm.get('pesoBalanzaOrigen').setValue('123');
        this._util.mensajeOKToast('Orden de compra correcta.');
      },
      error => {
        this._util.mensajeErroToast('Ocurrió un error al buscar la orden de compra.');
      }
    );
  }

  obtenerCentros() {
    this.centrosS.obtenerTodo().subscribe(
      resp => {
        this.centrosCmb = resp;
      }
    );
  }

  obtenerAlmacenes() {
    this.almacenS.obtenerTodo().subscribe(
      resp => {
        this.almacenesCmb = resp;
      }
    );
  }

  buscarPlacaTransporte(placa: string) {
    this.placaResponse = {} as IPlaca;
    this.placaS.obtenerPorId(placa).subscribe(
      resp => {
        if (resp) {
          this.placaResponse = resp;
          //this.agregarForm.get('chofer').setValue(resp.chofer.trim());
          //this.agregarForm.get('cedChofer').setValue(resp.cedula.trim());
          return;
        }
        //this.agregarForm.get('chofer').reset();
        //this.agregarForm.get('cedChofer').reset();
        this.placaResponse = {} as IPlaca;
        this._util.mensajeErroToast('Placa transportista incorrecto.');
      },
      error => {
        this.placaResponse = {} as IPlaca;
        //this.agregarForm.get('chofer').reset();
        //this.agregarForm.get('cedChofer').reset();
        this._util.mensajeErroToast('Ocurrió un error en la consulta de placa, inténtelo nuevamente.');
      }
    );
  }

  obtenerTipoOrdenBalanza() {
    this.loading = true;
    this.tipoOrdenesBalanzaS.obtener().subscribe(
      (resp) => {
        
        console.log('TIPO ORDENES', resp);        
        this.cmbTipoPermiteCambio = resp.filter(tipos => tipos.tipOrden > 0);
        this.cmbTipoOrdenAuxiliar = resp;
        this.cmbTipoOrden = resp;
        this.loading = false;
      },
      (error) => {
        this.cmbTipoOrden = [];
        this.loading = false;
      }
    );
  }

  obtenerOrdenesBalanza() {
    this.loading = true;
    let userData = JSON.parse(localStorage.getItem('datosUsuarioLogin'));
    
    this.ordenBalanzaS.buscarPorEstado("SALIDA", userData.login).subscribe(
      (resp) => {
        console.log("ORDEN DE BALANZA", resp)
        this.rowData = resp;
        this.loading = false;
      },
      (error) => {
        this.rowData = [];
        this.loading = false;
      }
    );
  }

  guardarCrearNueva(){
    if (this.agregarForm.invalid) return;
    this.loading = true;
    let data = this.agregarForm.getRawValue();
    let formData = Object.assign(
      {
        tipoOrden: { id: data.tipo },
        authTransp: { idAuthTransp: data.ticketAuth },
        ordenCompra: { idOrd: data.numero },
        bascula: { idBascula: data.ordenFija },
      },
      data,
      { origProv: 'origProv' }
    );

    formData.proveedor = data.proveedorId ? data.proveedorId.trim() : null;

    formData.fecha = formData.fecha.split('-').reverse().join('-') + 'T' + formData.horaEntrada + ':00';
    formData.fechIn = formData.fechIn.split('-').reverse().join('-') + 'T' + formData.horaEntrada + ':00';
    formData.fechOut = formData.fechOut.split('-').reverse().join('-') + 'T' + formData.horaSalida + ':00';

    console.log("formData", formData)

    this._util
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.procesar,
        text: `${this.agregarForm.get('idOrden').value ? 'Actualizar' : 'Nueva'} Orden de Balanza`,
        action: this.DAT_BTNS.nuevo,
        funcion: this.ordenBalanzaS.crearOrdenBalanza(formData),
      })
      .then((res: IOrdenBalanza) => {
        this.loading = false;

        console.log("ORDEN DE BALANZA CREADA");
        console.log("res", res);

        this.ordenBalanzaS.obtenerPorId(res.idOrden).subscribe(
          (resp) => {

            console.log("CONSULTA OB");
            console.log(resp);

            this.agregarForm.get("ocStatus").setValue(resp.ordenCompra.estado);
            this.agregarForm.get("solpedNumber").setValue(resp.ncasosSolped);
            this.agregarForm.get("ocNumber").setValue(resp.ordenCompra.idOrd);
            this.agregarForm.get("creationDateOC").setValue(resp.ordenCompra.fecha);

            this.loading = false;
          },
          (error) => {
            this.loading = false;
          }
        );

        if (this.capturaPesoIn) {
          this.capturaPesoInAction = true;
          this.agregarForm.get('pesoIn').disable({ onlySelf: true });
          this.agregarForm.get('idOrden').setValue(res.idOrden);
          this.capturaPesoIn = false;
        } else {
          this.obtenerOrdenesBalanza();
          this.closeModal();
        }
      })
      .catch((error) => {
        console.log(error)
        this.loading = false;
        console.log("si entra al error");
      })
      .finally(() => {
        console.log("si entra al finally");

      });
  }

  guardarEditar() {
    //this.getFormValidationErrors();
    //if (this.agregarForm.invalid) return;
    if (this.agregarForm.get('ordenFija').value == null || this.agregarForm.get('ordenFija').value == "") {
      this._util.mensajeErroToast('DEBE SELECCIONAR UNA BALANZA');
      return;
    }

    document.getElementById('cerrarModalPeso').click();
    this.agregarForm.get('pesoOut').setValue(this.fomularioPeso.get("pesoBalanza").value);
    this.loading = true;
    let data = this.agregarForm.getRawValue();

    let formData = Object.assign(
      {
        tipoOrden: { id: data.tipo },
        authTransp: { idAuthTransp: data.ticketAuth },
        ordenCompra: { idOrd: data.ocNumber },
        bascula: { idBascula: data.ordenFija },
      },
      data,
      { origProv: 'origProv' }
    );

    formData.pesoBruto = data.pesoBruto ? data.pesoBruto : 0;
    formData.pesoNeto = data.pesoNeto ? data.pesoNeto : 0;
    formData.proveedor = data.proveedorId ? data.proveedorId.trim() : null;

    formData.fecha = formData.fecha.split('-').reverse().join('-') + 'T' + formData.horaEntrada + ':00';
    formData.fechIn = formData.fechIn.split('-').reverse().join('-') + 'T' + formData.horaEntrada + ':00';
    formData.fechOut = formData.fechOut.split('-').reverse().join('-') + 'T' + formData.horaSalida + ':00';
    formData.ncasosSolped = formData.solpedNumber;
    //numero de orden Alternativo
    formData.numOrdAlt = data.tipo.tipOrden != 0 ? formData.numero: "";

    console.log("formData", formData)

    this._util
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.procesar,
        text: `${this.agregarForm.get('idOrden').value ? 'Actualizar' : 'Nueva'} Orden de Balanza`,
        action: this.DAT_BTNS.nuevo,
        funcion: this.ordenBalanzaS.reasignarBascula(formData),
      })
      .then((res: IOrdenBalanza) => {
        this.loading = false;

        console.log("ORDEN DE BALANZA ACTUALIZADA");
        console.log("res", res);

        if (this.capturaPesoIn) {
          this.capturaPesoInAction = true;
          this.agregarForm.get('pesoIn').disable({ onlySelf: true });
          this.agregarForm.get('idOrden').setValue(res.idOrden);
          this.capturaPesoIn = false;
        } else {
          this.obtenerOrdenesBalanza();
          this.closeModal();
        }
      })
      .catch((error) => {
        console.log(error)
        this.loading = false;
        console.log("si entra al error");
      })
      .finally(() => {
        console.log("si entra al finally");

      });
  }

  obtenerPorId(idbascula: number) {
    this.mantenimientoBasculaS.obtenerPorId(idbascula).subscribe(
      resp => {
        if (resp) {
          this.agregarForm.get('ordenFija').setValue(resp.idBascula);
          this.agregarForm.get('ordenFijaDescription').setValue(`${resp.desca}`);
          this.agregarForm.get('centroDest').setValue(resp.centros);

        }
      },
      error => {
        this._util.mensajeErroToast('Ocurrió un error al buscar la bascula asignada, inténtelo nuevamente.');
      }
    );
  }

  regresar() {
    this.ordenSelected = null;
  }

  editar({ rowData }) {

    this.ordenBalanzaS.obtenerPorId(rowData.idOrden).subscribe(
      resp => {

        console.log("ORDEN A EDITAR", resp);
        this.ordenSelected = resp;
        this.status = resp.estado;
        this.tipoDeOrden = resp.tipoOrden.tipOrden;
        this.tipoDeOrdenObj = resp.tipoOrden;
        this.isCreate = false;

        this.agregarForm.get('material')?.setValue(resp.material);
        this.agregarForm.get('estado')?.setValue(resp.estado);
        this.agregarForm.get('idOrden')?.setValue(resp.idOrden);
        this.agregarForm.get('fecha')?.setValue(formatDate(resp.fechIn, 'dd-MM-yyyy', 'en'));
               
        this.agregarForm.get('tipo')?.setValue(resp.tipoOrden.id);
        this.agregarForm.get("tipo").enable(); 

        this.agregarForm.get('numero')?.setValue(resp.numOrdAlt);
        this.agregarForm.get('factura')?.setValue(resp.factura);
        this.agregarForm.get('guia')?.setValue(resp.guia);
        this.agregarForm.get('proveedor')?.setValue(resp.proveedor);
        this.agregarForm.get('cliente')?.setValue(resp.cliente);
        this.agregarForm.get('ordBalanzaOrigen')?.setValue(resp.ordBalanzaOrigen);
        this.agregarForm.get('pesoBalanzaOrigen')?.setValue(resp.pesoBalanzaOrigen);
        this.agregarForm.get('sellos')?.setValue(resp.sellos);
        this.agregarForm.get('contenedor')?.setValue(resp.contenedor);
        this.agregarForm.get('placa')?.setValue(resp.authTransp.placa);
        this.agregarForm.get('chofer').setValue(resp.authTransp.chofer);
        this.agregarForm.get('cedChofer')?.setValue(resp.authTransp.cedula);
        this.agregarForm.get('centroOri')?.setValue(resp.centroOri);
        this.agregarForm.get('almanceOri')?.setValue(resp.almanceOri);
        this.agregarForm.get('centroDest')?.setValue(resp.centroDest);
        this.agregarForm.get('almaceDest')?.setValue(resp.almaceDest);
        this.agregarForm.get('origOrd')?.setValue(resp.origOrd);
        this.agregarForm.get('pesoBruto')?.setValue(resp.pesoBruto);
        this.agregarForm.get('pesoNeto')?.setValue(resp.pesoNeto);
        this.agregarForm.get('tara')?.setValue(resp.tara);
        this.agregarForm.get('acidez')?.setValue(resp.acidez);
        this.agregarForm.get('humedad')?.setValue(resp.humedad);
        this.agregarForm.get('impureza')?.setValue(resp.impureza);
        this.agregarForm.get('loteInsp')?.setValue(resp.loteInsp);

        this.agregarForm.get('decisionEmpleo')?.setValue(resp.decisionEmpleo);
        this.agregarForm.get('gradoApi')?.setValue(resp.gradoApi);

        this.agregarForm.get("ticketAuth").setValue(resp.authTransp.idAuthTransp);
        this.agregarForm.get("centroOri").setValue(resp.centroOri);
        this.agregarForm.get("centroDest").setValue(resp.centroDest);
        this.agregarForm.get("almaceDest").setValue(resp.almaceDest);
        this.agregarForm.get("almanceOri").setValue(resp.almanceOri);

        let userData = JSON.parse(localStorage.getItem('datosUsuarioLogin'));
        this.agregarForm.get('idusuario').setValue(userData.login);
        this.agregarForm.get('usuario').setValue(userData.login2);

        this.agregarForm.get('fechIn')?.setValue(formatDate(resp.fechIn, 'dd-MM-yyyy', 'en'));
        this.agregarForm.get('horaEntrada').setValue(formatDate(resp.fechIn, 'HH:mm', 'en'));
        this.agregarForm.get('pesoIn')?.setValue(resp.pesoIn);
        this.agregarForm.get('fechOut')?.setValue(formatDate(new Date(), 'dd-MM-yyyy', 'en'));
        this.agregarForm.get('horaSalida')?.setValue(formatDate(new Date(), 'HH:mm', 'en'));
        this.agregarForm.get('pesoOut').setValue(resp.pesoOut);
        this.agregarForm.get('idOrden').setValue(resp.idOrden);
        this.agregarForm.get('idusuario')?.setValue(resp.idusuario);

        this.agregarForm.get('inspectionLotAcidity')?.setValue(resp.acidezSap);
        this.agregarForm.get('inspectionLotMoisture')?.setValue(resp.humedadSap);
        this.agregarForm.get('inspectionLotImpurity')?.setValue(resp.impurezaSap);

        this.agregarForm.get("ticketAuth").disable();;
        this.agregarForm.get("proveedor").disable();;
        this.agregarForm.get("cliente").disable();;
        this.agregarForm.get("centroOri").disable();
        this.agregarForm.get("centroDest").disable();
        this.agregarForm.get("almaceDest").disable();
        this.agregarForm.get("almanceOri").disable();
        this.agregarForm.get("sellos").disable();
        this.agregarForm.get("contenedor").disable();
        this.agregarForm.get("material").disable();
        this.agregarForm.get('origOrd')?.disable();
        this.agregarForm.get('pesoBruto')?.disable();
        this.agregarForm.get('pesoNeto')?.disable();
        this.agregarForm.get('tara')?.disable();
        this.agregarForm.get('acidez')?.disable();
        this.agregarForm.get('humedad')?.disable();
        this.agregarForm.get('impureza')?.disable();
        this.agregarForm.get('loteInsp')?.disable();
        this.agregarForm.get('decisionEmpleo')?.disable();
        this.agregarForm.get('gradoApi')?.disable();
        this.agregarForm.get('placa')?.disable();

        this.agregarForm.get('horaEntrada')?.disable();
        this.agregarForm.get('fechIn')?.disable();
        this.agregarForm.get('pesoIn')?.disable();
        this.agregarForm.get('ordBalanzaOrigen').disable();

        this.agregarForm.get('ordenFija').setValue(resp.bascula.idBascula);
        this.agregarForm.get('ordenFijaDescription').setValue(resp.bascula.idBascula);
        //this.agregarForm.get('tipo')?.setValue(rowData.tipoOrden.id);

        switch (resp.tipoOrden.tipOrden) {
          case 0:
            console.log("COMPRA", resp)
            this.removeValidators();

            this.agregarForm.get("tipo").disable(); 
            this.agregarForm.get('cliente')?.disable({ onlySelf: true });
            this.agregarForm.get('centroOri')?.disable({ onlySelf: true });
            this.agregarForm.get('almanceOri')?.disable({ onlySelf: true });
            this.agregarForm.get('numero')?.disable({ onlySelf: true });
            this.agregarForm.get('centroDest').disable();

            console.log("resp.ingresa", resp.tipoOrden.ingresa)
            console.log("resp.tipoOrden.reqOrden", resp.tipoOrden.reqOrden)

            if (resp.tipoOrden.ingresa) this.showIngresoVacio = true;
            if (resp.tipoOrden.reqOrden) this.showNumeroDeOrden = true;
            
            if (resp.tipoOrden.paramCalidad) {
              this.agregarForm.get('acidez').setValidators([Validators.required]);
              this.agregarForm.get('acidez').updateValueAndValidity();
              this.agregarForm.get('humedad').setValidators([Validators.required]);
              this.agregarForm.get('humedad').updateValueAndValidity();
              this.agregarForm.get('impureza').setValidators([Validators.required]);
              this.agregarForm.get('impureza').updateValueAndValidity();
            }

            // EVITA SETEAR SOBRE NULO Y QUE DE ERROR. SETEAR PARA COMPRAS C/OC-AUTOMATIC
            //if (resp.tipoOrden.generaOcAuto == 1) {
              this.agregarForm.get("ocStatus").setValue(resp.ordenCompra.estado);
              this.agregarForm.get("solpedNumber").setValue(resp.ncasosSolped);
              this.agregarForm.get("ocNumber").setValue(resp.ordenCompra.idOrd);
              this.agregarForm.get("creationDateOC").setValue(resp.ordenCompra.fecha);
            //}

            this.agregarForm.get('cliente').setValidators([]);
            this.agregarForm.get('cliente').updateValueAndValidity();
            this.agregarForm.get('numero').setValidators([]);
            this.agregarForm.get('numero').updateValueAndValidity();
            this.agregarForm.get('guia').setValidators([]);
            this.agregarForm.get('guia').updateValueAndValidity();

            break;
          case 1:
            console.log("TIPO DE ORDEN ACTUAL VENTA", resp.tipoOrden)
            this.removeValidators();
            if (resp.tipoOrden.ingresa) {
              this.agregarForm.get("emptyIncome").setValue(true);
              this.showIngresoVacio = true;
            }
            
            console.log("reqOrden", resp.tipoOrden.reqOrden);
            
            this.cmbTipoOrden = this.cmbTipoPermiteCambio;            
            this.agregarForm.get('tipo')?.setValue(rowData.tipoOrden.id); 
            this.agregarForm.get("tipo").enable();

            if (resp.tipoOrden.reqOrden == 1) {
              this.showNumeroDeOrden = true;
              // requiere orden
              this.agregarForm.get('numero').setValidators([Validators.required]);
              this.agregarForm.get('numero').updateValueAndValidity();
            }

            if (resp.tipoOrden.paramCalidad) {
              this.agregarForm.get('acidez').setValidators([Validators.required]);
              this.agregarForm.get('acidez').updateValueAndValidity();
              this.agregarForm.get('humedad').setValidators([Validators.required]);
              this.agregarForm.get('humedad').updateValueAndValidity();
              this.agregarForm.get('impureza').setValidators([Validators.required]);
              this.agregarForm.get('impureza').updateValueAndValidity();
            }

            if (resp.tipoOrden.ingresa) {
              //this.agregarForm.get('numero').setValidators([]);              
              this.agregarForm.get("numero").enable();


            } else {
              this.agregarForm.get('numero').setValidators([Validators.required]);
              this.agregarForm.get('numero').updateValueAndValidity();
            }

            this.agregarForm.get("numero").setValue(this.ordenSelected.numOrdAlt);
            this.agregarForm.get("proveedor").disable();
            this.agregarForm.get("cliente").enable();
            this.agregarForm.get("emptyIncome").disable();
            this.agregarForm.get("centroDest").disable();
            this.agregarForm.get('material').enable();

            // TODO: Campos de llenado automático
            // this.agregarForm.controls['cliente'].setValue('CAMPO LLENADO AUTOMATICO');
            // this.agregarForm.controls['factura'].setValue('CAMPO LLENADO AUTOMATICO');
            // this.agregarForm.controls['placa'].setValue('CAMPO LLENADO AUTOMATICO');
            // this.agregarForm.controls['centro'].setValue('CAMPO LLENADO AUTOMATICO');
            // this.agregarForm.controls['almacen'].setValue('CAMPO LLENADO AUTOMATICO');
            // this.agregarForm.controls['lote'].setValue('CAMPO LLENADO AUTOMATICO');
            // this.agregarForm.controls['decision'].setValue('CAMPO LLENADO AUTOMATICO');
            // this.agregarForm.controls['gradoApi'].setValue('CAMPO LLENADO AUTOMATICO');
            break;
          case 2:
            console.log("TRASLADO", resp.tipoOrden)
            this.removeValidators();
            this.showNumeroDeOrden = true;

            this.agregarForm.get('numero').setValidators([Validators.required]);
            this.agregarForm.get('numero').updateValueAndValidity();

            this.agregarForm.get('numero').enable();
            this.agregarForm.get('centroOri').enable();
            this.agregarForm.get('almanceOri').enable();
            this.agregarForm.get('centroDest').enable();
            this.agregarForm.get('almaceDest').enable();

            this.agregarForm.get('cliente').disable();
            this.agregarForm.get('proveedor').disable();
            this.agregarForm.get('ordBalanzaOrigen').enable();
            

            break;
          case 3:
            this.agregarForm.get('pesoNeto').enable();
            this.removeValidators();
            this.agregarForm.get('numero').setValidators([Validators.required, Validators.pattern(/[A-Za-z]+/)]);
            this.agregarForm.get('numero').updateValueAndValidity();
            if (this.ingresoObligatorioParametrosCalidad) {
              this.agregarForm.get('acidez').setValidators([Validators.required, Validators.pattern(/[A-Za-z]+/)]);
              this.agregarForm.get('acidez').updateValueAndValidity();
              this.agregarForm.get('humedad').setValidators([Validators.required, Validators.pattern(/[A-Za-z]+/)]);
              this.agregarForm.get('humedad').updateValueAndValidity();
              this.agregarForm.get('impureza').setValidators([Validators.required, Validators.pattern(/[A-Za-z]+/)]);
              this.agregarForm.get('impureza').updateValueAndValidity();
            }

            this.agregarForm.get('material').enable();

            // TODO: Campos de llenado automático
            // this.agregarForm.controls['cliente'].setValue('CAMPO LLENADO AUTOMATICO');
            // this.agregarForm.controls['factura'].setValue('CAMPO LLENADO AUTOMATICO');
            // this.agregarForm.controls['placa'].setValue('CAMPO LLENADO AUTOMATICO');
            // this.agregarForm.controls['centro'].setValue('CAMPO LLENADO AUTOMATICO');
            // this.agregarForm.controls['almacen'].setValue('CAMPO LLENADO AUTOMATICO');
            // this.agregarForm.controls['lote'].setValue('CAMPO LLENADO AUTOMATICO');
            // this.agregarForm.controls['decision'].setValue('CAMPO LLENADO AUTOMATICO');
            // this.agregarForm.controls['gradoApi'].setValue('CAMPO LLENADO AUTOMATICO');
            break;
          case 4:
            this.agregarForm.get('pesoNeto').enable();
            this.removeValidators();

            this.agregarForm.get('material').enable();
            break;
          default:
            this.removeValidators();
            break;
        }

        this.onChangeMaterial('');
        this.onChangeProveedor('');
        this.onChangeCliente('');

        if (!resp.tipoOrden.reqOrden) {
          this.agregarForm.get('numero').setValidators([]);
          this.agregarForm.get('numero').updateValueAndValidity();
          this.showNumeroDeOrden = false;
          this.agregarForm.get('numero').disable();
        }

      },
      error => {
        this._util.mensajeErroToast('Ocurrió un error al buscar la orden de balanza, inténtelo nuevamente.');
      }
    );

  }

  acciones(event) {
    if (event === 'regresar') return this.closeModal();
    if (this.isCreate) this.guardarCrearNueva();
  }

  openModal() {
    document.getElementById('abrirModal').click();
  }

  closeModalPlaca() {
    document.getElementById('cerrarModal').click();
  }

  closeModal() {
    this.regresar();
  }

  keyDecimals(event: KeyboardEvent) {
    var charCode = event.which ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57))
      return false;

    return true;
  }

  keyAlphaNumeric(event: KeyboardEvent) {
    var regex = new RegExp('^[a-zA-Z0-9\b]+$');
    var key = String.fromCharCode(
      !event.charCode ? event.which : event.charCode
    );
    if (!regex.test(key)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  keyAlphaNumericCommaHyphen(event: KeyboardEvent) {
    var regex = new RegExp('^[a-zA-Z0-9\b]+$');
    var key = String.fromCharCode(
      !event.charCode ? event.which : event.charCode
    );
    if (key == "-" || key == ",") return true;
    if (!regex.test(key)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  keyNumeric(event: KeyboardEvent) {
    var ASCIICode = event.which ? event.which : event.keyCode;
    if (ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57)) return false;
    return true;
  }

  onChangeTipo(tipo) {

    // COMPRA: 0
    // VENTA: 1
    // TRASLADO: 2
    // INFORMATIVO: 3
    // MAQUILA: 4

    if (!tipo) return;

    this.tipoOrdenesBalanzaS.obtenerPorId(this.agregarForm.get("tipo").value).subscribe(
      (resp) => {
        if (!resp) return;

        this.tipoDeOrden = resp.tipOrden;
        this.agregarForm.get("orgCompra").setValue(resp.orgCompra);
        this.agregarForm.get("grupoCompra").setValue(resp.grupoCompra);
        this.agregarForm.get("clasePerdido").setValue(resp.clasePerdido);

        this.agregarForm.get("proveedor").enable();
        this.agregarForm.get('material').enable();
        this.agregarForm.get("cliente").enable();


        switch (resp.tipOrden) {
          case 0:
            console.log("COMPRA", resp)
            this.removeValidators();
            this.agregarForm.get('cliente')?.disable({ onlySelf: true });
            this.agregarForm.get('centroOri')?.disable({ onlySelf: true });
            this.agregarForm.get('almanceOri')?.disable({ onlySelf: true });
            this.agregarForm.get('numero')?.disable({ onlySelf: true });
            this.agregarForm.get('centroDest').disable();

            console.log("resp.ingresa", resp.ingresa)
            console.log("resp.reqOrden", resp.reqOrden)

            if (resp.ingresa) this.showIngresoVacio = true;
            if (resp.reqOrden) this.showNumeroDeOrden = true;
            if (resp.paramCalidad) {
              this.agregarForm.get('acidez').setValidators([Validators.required]);
              this.agregarForm.get('acidez').updateValueAndValidity();
              this.agregarForm.get('humedad').setValidators([Validators.required]);
              this.agregarForm.get('humedad').updateValueAndValidity();
              this.agregarForm.get('impureza').setValidators([Validators.required]);
              this.agregarForm.get('impureza').updateValueAndValidity();
            }

            this.agregarForm.get('cliente').setValidators([]);
            this.agregarForm.get('cliente').updateValueAndValidity();
            this.agregarForm.get('numero').setValidators([]);
            this.agregarForm.get('numero').updateValueAndValidity();
            this.agregarForm.get('guia').setValidators([]);
            this.agregarForm.get('guia').updateValueAndValidity();

            // TODO: Campos de llenado automático
            // this.agregarForm.controls['proveedor'].setValue('CAMPO LLENADO AUTOMATICO');
            // this.agregarForm.controls['placa'].setValue('CAMPO LLENADO AUTOMATICO');
            break;
          case 1:
            console.log("VENTA", resp)
            this.removeValidators();
            if (resp.ingresa) {
              this.agregarForm.get("emptyIncome").setValue(true);
              this.showIngresoVacio = true;
            }

           // if (resp.reqOrden && !resp.ingresa) {
             // this.showNumeroDeOrden = false;
            //}
            
            if (resp.paramCalidad) {
              this.agregarForm.get('acidez').setValidators([Validators.required]);
              this.agregarForm.get('acidez').updateValueAndValidity();
              this.agregarForm.get('humedad').setValidators([Validators.required]);
              this.agregarForm.get('humedad').updateValueAndValidity();
              this.agregarForm.get('impureza').setValidators([Validators.required]);
              this.agregarForm.get('impureza').updateValueAndValidity();
            }

            this.showNumeroDeOrden = true;
            /*
            if (resp.ingresa) {
              this.agregarForm.get('numero').setValidators([]);
              this.agregarForm.get('numero').updateValueAndValidity();
              this.agregarForm.get("numero").enable();

            } else {
              this.agregarForm.get('numero').setValidators([Validators.required]);
              this.agregarForm.get('numero').updateValueAndValidity();
            }*/

            this.agregarForm.get("numero").enable();
            this.agregarForm.get('numero').setValidators([]);
            this.agregarForm.get('numero').updateValueAndValidity();

            this.agregarForm.get("emptyIncome").disable();

           /* if (resp.reqOrden && !resp.ingresa) {
              this.showNumeroDeOrden = false;
              this.agregarForm.get('numero').setValidators([]);
              this.agregarForm.get('numero').updateValueAndValidity();
            }*/

            //27-12-2023 | Habilita campo según tipo de orden
            this.agregarForm.get('centroOri').enable();
            this.agregarForm.get('almanceOri').enable();
            this.agregarForm.get('centroDest').enable();
            this.agregarForm.get('almaceDest').enable();

            // TODO: Campos de llenado automático
            // this.agregarForm.controls['cliente'].setValue('CAMPO LLENADO AUTOMATICO');
            // this.agregarForm.controls['factura'].setValue('CAMPO LLENADO AUTOMATICO');
            // this.agregarForm.controls['placa'].setValue('CAMPO LLENADO AUTOMATICO');
            // this.agregarForm.controls['centro'].setValue('CAMPO LLENADO AUTOMATICO');
            // this.agregarForm.controls['almacen'].setValue('CAMPO LLENADO AUTOMATICO');
            // this.agregarForm.controls['lote'].setValue('CAMPO LLENADO AUTOMATICO');
            // this.agregarForm.controls['decision'].setValue('CAMPO LLENADO AUTOMATICO');
            // this.agregarForm.controls['gradoApi'].setValue('CAMPO LLENADO AUTOMATICO');
            break;
          case 2:
            console.log("TRASLADO", resp)
            this.removeValidators();

            this.showNumeroDeOrden = true;
            this.agregarForm.get('numero').enable();
            this.agregarForm.get('numero').setValidators([]);
            this.agregarForm.get('numero').updateValueAndValidity();
            
            this.agregarForm.get('centroOri').enable();
            this.agregarForm.get('almanceOri').enable();
            this.agregarForm.get('centroDest').enable();
            this.agregarForm.get('almaceDest').enable();

            //this.agregarForm.get('cliente').disable();
            //this.agregarForm.get('proveedor').disable();

            this.agregarForm.get('ordBalanzaOrigen').enable();
            this.agregarForm.get('material').enable();

            break;
          case 3:
            // INFROMATIVA
            this.removeValidators();
            this.agregarForm.get('numero').setValidators([]);
            this.agregarForm.get('numero').updateValueAndValidity();

            if (this.ingresoObligatorioParametrosCalidad) {
              this.agregarForm.get('acidez').setValidators([Validators.required, Validators.pattern(/[A-Za-z]+/)]);
              this.agregarForm.get('acidez').updateValueAndValidity();
              this.agregarForm.get('humedad').setValidators([Validators.required, Validators.pattern(/[A-Za-z]+/)]);
              this.agregarForm.get('humedad').updateValueAndValidity();
              this.agregarForm.get('impureza').setValidators([Validators.required, Validators.pattern(/[A-Za-z]+/)]);
              this.agregarForm.get('impureza').updateValueAndValidity();
            }

            this.agregarForm.get('material').setValidators([]);
            this.agregarForm.get('material').updateValueAndValidity();
            this.agregarForm.get('material').enable();

            // TODO: Campos de llenado automático
            // this.agregarForm.controls['cliente'].setValue('CAMPO LLENADO AUTOMATICO');
            // this.agregarForm.controls['factura'].setValue('CAMPO LLENADO AUTOMATICO');
            // this.agregarForm.controls['placa'].setValue('CAMPO LLENADO AUTOMATICO');
            // this.agregarForm.controls['centro'].setValue('CAMPO LLENADO AUTOMATICO');
            // this.agregarForm.controls['almacen'].setValue('CAMPO LLENADO AUTOMATICO');
            // this.agregarForm.controls['lote'].setValue('CAMPO LLENADO AUTOMATICO');
            // this.agregarForm.controls['decision'].setValue('CAMPO LLENADO AUTOMATICO');
            // this.agregarForm.controls['gradoApi'].setValue('CAMPO LLENADO AUTOMATICO');
            break;
          case 4:
            this.removeValidators();

            //if (resp.reqOrden) {
              this.showNumeroDeOrden = true;
              this.agregarForm.get('numero').enable();
              this.agregarForm.get('numero').setValidators([Validators.required, Validators.pattern(/[A-Za-z]+/)]);
              this.agregarForm.get('numero').updateValueAndValidity();
            //}

            this.agregarForm.get('cliente').enable();
            this.agregarForm.get('material').enable();
            this.agregarForm.get('proveedor').enable();
            this.agregarForm.get('centroOri').enable();
            this.agregarForm.get('almanceOri').enable();

            break;
          default:
            this.removeValidators();
            break;
        }

        this.loading = false;
      },
      (error) => {
        this.loading = false;
      }
    );
  }

  removeValidators() {
    for (const key in this.agregarForm.controls) {
      this.agregarForm.get(key).clearValidators();
      this.agregarForm.get(key).updateValueAndValidity();
    }
    this.agregarForm.get('tipo').setValidators([Validators.required]);
    this.agregarForm.get('tipo').updateValueAndValidity();
  }

  capturaDePesoEntrada() {
    this.capturaPesoIn = true;
    this.guardarCrearNueva()
  }

  capturaDePesoSalida() {
    //CAPTURAR PESO
    document.getElementById('fillOne').click();
    this.loading = true;
    let userData = JSON.parse(localStorage.getItem('datosUsuarioLogin'));

    this.ordenBalanzaS.obtenerPesoByUser(userData.login2).subscribe(
      // this.ordenBalanzaS.obtener().subscribe(
      (resp) => {
        console.log("obtenerPeso", resp);
        this.fomularioPeso.get("pesoBalanza").setValue(resp.peso);
        this.agregarForm.get("pesoOut").setValue(resp.peso);
        this.loading = false;
      },
      (error) => {
        this.loading = false;
      });
    //this.guardarEditar();
  }

  imprimirCapturaEntrada() {
    this.imprimirCapturaEntradaLoading = true;
    this.ordenBalanzaS.imprimirCapturaEntrada(this.ordenSelected).subscribe(
      (resp) => {
        if (resp) {
          this._util.descargarArchivo("Orden-Balanza-" + resp.idOrden + ".pdf", resp);
          // printJS({
          //   printable: resp,
          //   type: 'pdf',
          //   base64: true,
          // });
          this.imprimirCapturaEntradaLoading = false;
          return;
        }
        this._util.mensajeErroToast('No se pudo imprimir correctamente.');
        this.imprimirCapturaEntradaLoading = false;
      },
      (error) => {
        console.log(error);
        this.imprimirCapturaEntradaLoading = false;
      }
    );
  }

  imprimirCapturaSalida() {
    this.loading = true;
    this.imprimirCapturaSalidaLoading = true;
    this.ordenBalanzaS.imprimirCapturaSalida(this.ordenSelected).subscribe(
      (resp) => {
        if (resp) {
          this._util.descargarArchivo("Orden-Balanza-" + resp.idOrden + ".pdf", resp);
          // printJS({
          //   printable: resp,
          //   type: 'pdf',
          //   base64: true,
          // });
          this.imprimirCapturaSalidaLoading = false;
          return;
        }
        this._util.mensajeErroToast('No se pudo imprimir correctamente.');
        this.imprimirCapturaSalidaLoading = false;
        this.loading = false;
      },
      (error) => {
        console.log(error);
        this.imprimirCapturaSalidaLoading = false;
        this.loading = false;
      }
    );
  }

  digiteTicketAutorizacionValidDuplicated() {

    this.digiteTicketAutorizacionDuplicated = false;

    for (let i = 0; i < this.rowData.length; i++) {
      if (this.rowData[i].authTransp.idAuthTransp == this.agregarForm.get('ticketAuth').value) {
        this.digiteTicketAutorizacionDuplicated = true;
        break;
      }
    }

  }

  public materialObj;

  onChangeMaterial(event: any) {
    if (event.key == " " || event.code == "Space" || event.keyCode == 32) return;
    this.loading = true;
    console.log("MATERIAL", this.agregarForm.get("material").value)
    if (this.agregarForm.get("material").value) {
      this.materialS.obtenerPorId(this.agregarForm.get("material").value.trim()).subscribe(
        (resp) => {
          this.materialObj = resp;
          if (resp) {
            this.materialInvalido = false;
            this.agregarForm.controls['desmat'].setValue(resp.idMaterial + " - " + resp.dscaMaterial);
          } else {
            this.materialInvalido = true;
            this.agregarForm.controls['desmat'].setValue('');
          }
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.materialInvalido = true;
          this.agregarForm.controls['desmat'].setValue('');
        }
      );
    }
  }

  onChangeProveedor(event: any) {
    this.getFormValidationErrors();
    if (event.key == " " || event.code == "Space" || event.keyCode == 32) return;
    this.loading = true;
    this.agregarForm.controls['despro'].setValue('');
    if (this.agregarForm.get("proveedor").value) {
      if (this.agregarForm.get("proveedor").value != null && this.agregarForm.get("proveedor").value.length > 0) {
        this.proveedorS.obtenerPorId(this.agregarForm.get("proveedor").value.trim()).subscribe(
          (resp) => {
            if (resp) {
              this.proveedorInvalido = false;
              this.agregarForm.controls['proveedor'].setValue(resp.ruc);
              this.agregarForm.controls['despro'].setValue(resp.idProveedor + " - " + resp.nombre);
              this.agregarForm.controls['proveedorId'].setValue(resp.idProveedor);
            } else {
              this.proveedorInvalido = true;
              this.agregarForm.controls['despro'].setValue('');
            }
            this.loading = false;
          },
          (error) => {
            this.loading = false;
            this.proveedorInvalido = true;
            this.agregarForm.controls['despro'].setValue('');
          }
        );
      }
    }
  }

  onChangeCliente(event: any) {
    if (event.key == " " || event.code == "Space" || event.keyCode == 32) return;
    this.loading = true;
    if (this.agregarForm.get("cliente").value) {
      if (this.agregarForm.get("cliente").value != null && this.agregarForm.get("cliente").value.length > 0) {
        this.clienteS.obtenerPorId(this.agregarForm.get("cliente").value.trim()).subscribe(
          (resp) => {
            if (resp) {
              this.clienteInvalido = false;
              this.agregarForm.controls['descli'].setValue(resp.idCliente + " - " + resp.nombreCliente1);
            } else {
              this.clienteInvalido = true;
              this.agregarForm.controls['descli'].setValue('');
            }
            this.loading = false;
          },
          (error) => {
            this.loading = false;
            this.clienteInvalido = true;
            this.agregarForm.controls['descli'].setValue('');
          }
        );
      }
    }
  }

  getFormValidationErrors() {

    console.log('%c ==>> Validation Errors: ', 'color: red; font-weight: bold; font-size:25px;');

    let totalErrors = 0;

    Object.keys(this.agregarForm.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.agregarForm.get(key).errors;
      if (controlErrors != null) {
        totalErrors++;
        Object.keys(controlErrors).forEach(keyError => {
          console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });

    console.log('Number of errors: ', totalErrors);

    if(totalErrors > 0 ){
      this._util.mensajeErroToast('Faltan datos, favor revise');
    }

  }

  origenesExtractoras;
  obtenerOrigenesExtractoras() {
    this.loading = true;
    this.MantenimientoOrigenesExtractorasService.obtener().subscribe(
      (resp) => {
        resp.map(item => {
          if (item["estado"] == "ACTIVO") {
            return item;
          }
        })
        this.origenesExtractoras = resp;
        this.loading = false;
      },
      (error) => {
        this.origenesExtractoras = [];
        this.loading = false;
      }
    )
  }


obtenerBalanzas() {
  this.loading = true;
 
  this.mantenimientoBasculaS.obtener().subscribe(
    (resp) => {
      console.log('balanzas', resp);      
      this.comboBalanzas = resp.filter(todo=> todo.estado == "ACTIVO");
      console.log(this.comboBalanzas);

      this.loading = false;
    },
    (error) => {
      this.rowData = [];
      this.loading = false;
    }
  );

}


imprimirSalida({ rowData }){

  if (rowData.pesoOut == null || rowData.pesoOut <= 0){
    this._util.mensajeErroToast('Orden de Balanza sin peso de salida');
    return;
  }

  this.ordenBalanzaS.imprimirCapturaSalida(rowData).subscribe(
    (resp) => {
      if (resp) {
        this._util.descargarArchivo("Orden-Balanza-Salida" + rowData.idOrden + ".pdf", resp);
        this.imprimirCapturaSalidaLoading = false;
        return;
      }
      this._util.mensajeErroToast('No se pudo imprimir correctamente.');
      this.imprimirCapturaSalidaLoading = false;
    },
    (error) => {
      console.log(error);
      this.imprimirCapturaSalidaLoading = false;
    }
  );

}

cerrarModalPeso(){
  document.getElementById('cerrarModalPeso').click();
}

onChangePeso(){
  this.agregarForm.get('pesoOut').setValue(this.fomularioPeso.get("pesoBalanza").value);
}

validaciones(){}

}
